<template>
  <v-list
    class="py-0"
    dense
  >
    <v-list-item
      v-for="field in layer.details.filter(f => (!linkField || linkField.key !== f) && (!attachmentField || attachmentField.key !== f))"
      :key="field"
      class="px-0"
      style="min-height:24px;max-width:100%"
      two-line
    >
      <v-list-item-content class="py-1">
        <v-list-item-title>
          {{ fields[field].title || fields[field]['x-originalName'] || fields[field].key }}
        </v-list-item-title>
        <v-list-item-subtitle
          v-if="data"
          style="white-space: normal;"
        >
          <template v-if="!fields[field].separator">
            {{ formatField(data, fields[field])+'' }}
          </template>
          <template
            v-for="value in data[field].split(fields[field].separator).sort().slice(0, 3)"
            v-else-if="data[field]"
          >
            <v-chip
              :key="value"
              small
              style="flex:none"
              class="my-1 mr-1"
            >
              {{ (formatField({ [field]: value }, fields[field]) + '') }}
            </v-chip>
          </template>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item
      v-if="data && linkField && data[linkField.key]"
      class="px-0"
    >
      <v-list-item-content class="py-1">
        <v-list-item-title>
          <a
            :href="(!data[linkField.key].includes('http') ? 'http://' : '') + data[linkField.key]"
            target="_blank"
          >Page associée</a>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item
      v-if="data && attachmentField && data[attachmentField.key]"
      class="px-0"
    >
      <v-list-item-content class="py-1">
        <v-list-item-title>
          <a
            :href="(!data[attachmentField.key].includes('http') ? (dataset.href + '/attachments/') : '') + data[attachmentField.key]"
            target="_blank"
          >Document attaché</a>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import axios from 'axios'
import { formatField } from '@data-fair/components-app/format/fields'

export default {
  props: {
    feature: { type: Object, required: true }
  },
  data: () => ({
    data: null
  }),
  computed: {
    ...mapState(['datasets']),
    ...mapGetters(['config', 'datasetInfos']),
    layer () {
      return this.config.layers.find(l => l.dataset.id === this.feature.source)
    },
    fields () {
      return this.datasets[this.feature.source].schema.reduce((a, b) => { a[b.key] = b; return a }, {})
    },
    attachmentField () {
      return this.datasets[this.feature.source].schema.find(f => f['x-refersTo'] === 'http://schema.org/DigitalDocument')
    },
    linkField () {
      return this.datasets[this.feature.source].schema.find(f => f['x-refersTo'] === 'https://schema.org/WebPage')
    }
  },
  watch: {
    feature () {
      this.refresh()
    }
  },
  mounted () {
    this.refresh()
  },
  methods: {
    async refresh () {
      if (!this.layer) this.data = null
      else {
        const params = {
          qs: `_id:"${this.feature.id}"`,
          select: this.layer.details.join(',')
        }
        this.data = (await axios.get(this.datasetInfos[this.layer.dataset.id].href + '/lines', { params })).data.results[0]
      }
    },
    formatField
  }
}
</script>
